import { ArrowRight } from "lucide-react";
import { BrutalistBadge, GlassCard } from "@/app/components/brand-scaffold";
import { objectionsQA } from "@/design-system/registry/homepage";

const glassCardProps = {
  bgClass: "bg-white/75",
  hoverClass: "hover:bg-white/95",
  className: "!p-6 flex flex-col",
} as const;

export function HomepageFaq() {
  return (
    <section className="px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
      <div className="mx-auto max-w-5xl">
        <div className="mb-8">
          <BrutalistBadge bgClass="bg-white" hoverBgClass="hover:bg-black" hoverTextClass="hover:text-white">
            FAQ
          </BrutalistBadge>
        </div>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-black mb-10">
          常见问题
        </h2>
        <div className="space-y-6">
          {objectionsQA.map((qa) => (
            <GlassCard key={qa.num} {...glassCardProps}>
              <h3 className="font-black text-lg text-black mb-3">{qa.question}</h3>
              <div className="space-y-2">
                {qa.bodyLines.map((line, idx) => (
                  <p key={idx} className="text-sm text-zinc-700">{line}</p>
                ))}
              </div>
            </GlassCard>
          ))}
        </div>
        <a href="/faq" className="inline-flex items-center gap-1.5 mt-8 font-black text-sm text-black hover:text-[#3B82F6] transition-colors">
          查看全部 FAQ <ArrowRight className="h-4 w-4" strokeWidth={3} />
        </a>
      </div>
    </section>
  );
}
